import { EmailValueProp, EmailToneType } from "./db";

export type CustomJsonLink = {
  'url': string
  'text': string
}

export function jsonSafeToCustomJsonLink(record: Record<string, any>): CustomJsonLink {
  return {
    'url': record.url,
    'text': record.text
  }
}

export type CustomJsonLinks = {
  'header': string
  'urls': CustomJsonLink[]
  'data'?: string
  'content'?: string
}

export function jsonSafeToCustomJsonLinks(record: Record<string, any>): CustomJsonLinks {
  return {
    'header': record.header,
    'urls': record.urls ? record.urls.map((v: Record<string, any>) => jsonSafeToCustomJsonLink(v)) : [],
    'data': record.data ? record.data : undefined,
    'content': record.content ? record.content : undefined
  }
}

export type SummarizerResult = {
  'summary': string | null
  'header_and_content'?: { 'header': string; 'content': string} []
  'custom_json': CustomJsonLinks[] | null
}

export function jsonSafeToSummarizerResult(record: Record<string, any>): SummarizerResult {
  return {
    'summary': record.summary,
    'header_and_content': record.header_and_content ? record.header_and_content : undefined,
    'custom_json': record.custom_json ? record.custom_json.map((v: Record<string, any>) => jsonSafeToCustomJsonLinks(v)) : null
  }
}

export enum EMAIL_INPUT {
  PROSPECT_NAME = 'prospect_name',
  PROSPECT_COMPANY = 'prospect_company',
  PROSPECT_TITLE = 'prospect_title',
  LINKEDIN = 'linkedin',
  WEBSITE = 'website',
  TRANSCRIPTS = 'transcripts'
}
export type ProspectEmailInput = {
  prospect_name: string | null
  prospect_company: string | null
  prospect_title: string | null
  linkedin_summary: string | null
  website_summary: string | null
}

export type EmailGenRequest = {
  prospect_id: string
  value_prop: EmailValueProp
  previous_session_ids: string[]
  selected_session_ids: string[]
  prospect_info: ProspectEmailInput
}

export type LinkedInGenRequest = {
  platform_person_url: string
  prospect_name: string
  value_prop: EmailValueProp
  message_history: string | null
  research: string | null
}

export type CustomEditInfo = {
  uuid: string
  custom_tone: EmailToneType | null
  custom_instructions: string | null
}
export enum RequestState {
  DEFAULT = 'DEFAULT',
  PENDING = 'PENDING',
  REQUESTED_BY_USER = 'REQUESTED_BY_USER',
  TO_BE_REQUESTED_BY_USER = 'TO_BE_REQUESTED_BY_USER',
  RECEIVED = 'RECEIVED',
  ERROR = 'ERROR'
}
////////////////////////////////////////////
// TextSummaryResult is the reslt type of `request-text-summary`
////////////////////////////////////////////


export type TextSummaryResult = {
  summary?: string
}

// EmailResult is the reslt type of `request-email`
////////////////////////////////////////////


export type EmailResult = {
  email?: string
}